// src/lib/form-i18n.js — LOT B5 (formulaire voyageur trilingue)
//
// Dictionnaire STATIQUE du chrome + du texte RGPD du formulaire voyageur
// (PublicFormPage). Décision Dimitri : le juridique (RGPD) et le chrome NE sont
// PAS traduits par IA — ils vivent ici en 3 langues validées au mot. Seul le
// contenu saisi par l'admin (titre, description, labels de champs, options) est
// auto-traduit par Claude côté serveur (api/form-config?lang=).
//
// Le texte RGPD `rgpd_body` est la SOURCE UNIQUE : RgpdPieceNotice (C4) le lit
// d'ici → zéro divergence entre le repli C4 et la déclinaison B5. {email} est
// rendu en lien mailto par le composant.
//
// Langues : fr (source) | en | es. Fallback systématique → fr si clé/locale
// absente (defense-in-depth).

export const FORM_LOCALES = ['fr', 'en', 'es']
export const DEFAULT_FORM_LOCALE = 'fr'
export const FORM_CONTACT_EMAIL = 'contact@fullbnbzen.com'

// Libellés du sélecteur de langue (drapeau + code court).
export const FORM_LOCALE_LABELS = {
  fr: '🇫🇷 FR',
  en: '🇬🇧 EN',
  es: '🇪🇸 ES',
}

// Dictionnaire. {x}, {h}, {d1}, {d2}, {email}, {action} = variables interpolées.
const DICT = {
  fr: {
    // Formulaire DÉJÀ ENVOYÉ (défaut voyageur 01/10) — lecture seule.
    recu_titre: 'Bien reçu le {date}',
    recu_titre_sans_date: 'Bien reçu',
    recu_intro: 'Votre formulaire nous est bien parvenu. Voici vos réponses.',
    recu_modif: 'Pour changer une réponse, écrivez-nous à {email}.',
    recu_piece: "Pièce d'identité reçue",
    recu_btn_modifier: 'Modifier mes réponses',
    recu_modifiable: "Vous pouvez modifier vos réponses jusqu'au {date} (heure de Paris).",
    recu_modifiable_jour: "Vous pouvez modifier vos réponses jusqu'à la veille de votre arrivée.",
    recu_trop_tard: "Trop tard pour modifier en ligne : votre changement n'a pas été enregistré. Écrivez-nous.",
    recu_autre_reponse: "Votre envoi n'a pas été enregistré : une réponse avait déjà été reçue pour ce séjour. Pour changer quelque chose, écrivez-nous.",
    recu_autre_reponse_modifiable: "Votre envoi n'a pas été enregistré : une réponse avait déjà été reçue pour ce séjour. Pour changer quelque chose, utilisez « Modifier mes réponses ».",
    recu_garder: 'Déjà reçu — laissez vide pour garder',
    recu_email_aide: 'Pour changer votre adresse e-mail, écrivez-nous.',
    recu_val_adresse: 'Adresse reçue',
    recu_val_message: 'Message reçu',
    recu_val_reponse: 'Réponse reçue',
    recu_envoi_en_cours: 'Votre envoi est en cours de traitement. Rechargez la page dans un instant.',
    recu_verif_impossible: 'Vérification impossible pour le moment. Réessayez dans un instant.',
    hero_subtitle: 'Préparons ensemble votre arrivée',
    stay_label: 'Votre séjour',
    stay_dates: 'Du {d1} au {d2}',
    piece_group_title: "Pièce d'identité",
    piece_subtext_passport: 'Photographiez la page contenant votre photo et vos informations.',
    piece_subtext_recto: "Face avant de votre carte d'identité.",
    piece_subtext_verso: "Face arrière de votre carte d'identité.",
    submit: '✓ Confirmer mon arrivée',
    submitting: '⏳ Envoi en cours…',
    thanks_title: '✅ Merci !',
    thanks_msg: 'Votre formulaire a bien été reçu. Nous reviendrons vers vous rapidement.',
    redirecting: 'Redirection en cours…',
    back_to_booking: 'Retour à votre réservation…',
    error_title: '⚠️ Lien invalide',
    error_help: "Si vous pensez que c'est une erreur, contactez votre conciergerie.",
    loading: 'Chargement…',
    required_field: 'Le champ « {x} » est obligatoire.',
    upload_required: 'Veuillez téléverser « {x} » avant de confirmer.',
    upload_in_progress: "L'envoi de « {x} » est en cours, patientez quelques secondes.",
    time_from: 'À partir de {h}',
    checkout_before: 'Check-out avant {h}',
    slot_placeholder: '— Choisir un créneau —',
    select_placeholder: '— Sélectionner —',
    upload_sending: '⏳ Envoi en cours…',
    upload_done: '✓ Document envoyé',
    // E1a — chemin 409-succès (B1) : le serveur a gardé l'ANCIEN document, le
    // fichier fraîchement choisi n'est jamais parti → libellé générique, JAMAIS
    // le nom du nouveau fichier (la ligne verte ne doit pas mentir).
    upload_already_received: '✓ Document déjà reçu',
    upload_replace_hint: 'Sélectionnez à nouveau un fichier pour {action}.',
    upload_action_replace: 'remplacer',
    upload_action_retry: 'réessayer',
    upload_err_format: 'Format non supporté, réessayez en JPEG ou PDF.',
    upload_err_generic: "L'envoi a échoué. Réessayez.",
    rgpd_toggle: 'Vos données sont protégées',
    rgpd_more: 'en savoir plus',
    rgpd_less: 'masquer',
    rgpd_body: "Le document que vous téléversez (passeport ou carte d'identité) sert uniquement à vérifier votre identité pour votre séjour. Il est stocké de façon sécurisée et privée, accessible à la seule conciergerie FULLBNBZEN, et supprimé automatiquement 15 jours après la fin de votre séjour. Conformément au RGPD, vous pouvez demander à y accéder ou à le faire supprimer à {email}.",
    // Libellés d'AFFICHAGE des options id_type. La VALEUR stockée reste FR
    // canonique (« Passeport » / « Carte d'identité ») pour ne pas casser
    // l'affichage conditionnel (shouldRenderField compare la valeur FR).
    piece_opt_passport: 'Passeport',
    piece_opt_ci: "Carte d'identité",
    // Titre de séjour (décision 3, 2026-09-06) — libellé d'AFFICHAGE ; la
    // VALEUR stockée reste la FR canonique « Titre de séjour ».
    piece_opt_ts: 'Titre de séjour',
    piece_subtext_ts_recto: 'Face avant de votre titre de séjour.',
    piece_subtext_ts_verso: 'Face arrière de votre titre de séjour.',

    // ── FORMULAIRE V2 (refonte 2026-09, maquette formulaire-proto.html) ──
    // Textes FR repris AU MOT PRÈS de la maquette + remplacements actés
    // (décisions Dimitri 2026-09-06 : phrase hors-créneau, RGPD contrôle IA,
    // sous-texte de persistance aligné sur le vrai mécanisme — Q-PERSISTANCE).
    v2_bonjour: 'Bonjour {prenom}',
    v2_bonjour_sans_prenom: 'Bonjour',
    v2_merci_titre: 'Merci, {prenom} !',
    v2_merci_titre_sans_prenom: 'Merci !',
    v2_lien_expire: 'Lien expiré',
    v2_quand_jours: 'Arrivée dans {n} jours',
    v2_quand_jour: 'Arrivée dans 1 jour',
    v2_quand_demain: 'Arrivée demain',
    v2_quand_aujourdhui: 'Arrivée aujourd’hui',
    // Anneau — phrases maquette (« le fait, pas l'étape »).
    v2_fait: '{n}/{tot} fait',
    v2_faits: '{n}/{tot} faits',
    v2_tout_rempli: 'Tout est rempli, vous pouvez envoyer.',
    v2_plus_que: 'Plus que {x}.',
    v2_il_reste: 'Il reste {liste} et {dernier}.',
    // Cartes-sections.
    v2_carte_vous: 'Vos coordonnées',
    v2_carte_horaires: 'Vos horaires',
    v2_carte_piece: "Votre pièce d’identité",
    v2_carte_piece_sous: 'la loi nous oblige à la recueillir',
    v2_carte_mot: 'Un mot pour nous',
    v2_carte_autre: 'Autre',
    v2_facultatif: 'facultatif',
    // Libellés maquette des champs standard (rendus SEULEMENT si l'admin n'a
    // pas personnalisé le libellé — sinon son libellé prime).
    v2_label_email: 'Votre email',
    v2_label_phone: 'Votre téléphone',
    v2_label_notes: 'Quelque chose à nous signaler ?',
    v2_ph_notes: 'Une question sur le logement, un besoin particulier…',
    v2_label_arrivee: 'Arrivée',
    v2_label_depart: 'Départ',
    // Erreurs sous champ.
    v2_err_email: 'Cette adresse ne semble pas valide — vérifiez le @ et le point.',
    v2_err_champ: 'Ce champ est obligatoire.',
    v2_err_horaire: 'Choisissez un créneau.',
    v2_err_piece: 'Envoyez ce document avant de confirmer.',
    v2_err_piece_en_cours: "L'envoi de ce document est en cours, patientez quelques secondes.",
    // Horaires — la phrase hors-créneau REMPLACE la fin de phrase maquette
    // (décision 5 : jamais un renvoi vers une porte fermée). « Écrivez-nous »
    // se rend en lien mailto (v2_hc_lien + v2_hc_suite).
    v2_horaires_phrase: 'Entrée à partir de {checkin}, départ avant {checkout}. ',
    v2_hc_lien: 'Écrivez-nous',
    v2_hc_suite: ' si vous arrivez en dehors de ces horaires.',
    v2_apres_23h: 'après 23h',
    // Pièce d'identité.
    v2_quel_document: 'Quel document ?',
    v2_page_photo: 'La page avec votre photo',
    v2_aide_photo: 'Une photo nette où le nom et la date de validité se lisent.',
    v2_prendre_photo: 'Prendre en photo',
    v2_appareil: "l’appareil s’ouvre",
    v2_choisir_fichier: 'Choisir un fichier',
    v2_depuis_tel: 'depuis mon téléphone',
    v2_reprendre_photo: 'Reprendre la photo',
    v2_envoi_doc: 'Envoi en cours…',
    v2_verif_doc: 'Vérification de votre document…',
    v2_doc_envoye: 'Document envoyé',
    v2_doc_recu: 'Document reçu',
    v2_retirer_doc: 'Retirer ce document',
    // Verdicts ambre — phrases composées CLIENT depuis les ÉNUMS serveur (J2 :
    // aucun texte libre du modèle n'atteint jamais le voyageur). Le constat
    // porte la zone éventuelle ({zone}), le conseil dit comment reprendre.
    v2_ambre_flou_titre: 'La photo est un peu floue{zone}',
    v2_ambre_flou_conseil: 'Reprenez-la à plat, sans reflet.',
    v2_ambre_reflet_titre: 'Un reflet gêne la lecture{zone}',
    v2_ambre_reflet_conseil: "Reprenez la photo sans flash, loin d'une lampe.",
    v2_ambre_cadrage_titre: 'Le document est coupé{zone}',
    v2_ambre_cadrage_conseil: 'Reprenez-le en entier dans le cadre.',
    v2_ambre_sombre_titre: 'La photo est trop sombre{zone}',
    v2_ambre_sombre_conseil: "Reprenez-la près d'une fenêtre.",
    v2_ambre_tronque_titre: 'Une partie du document manque{zone}',
    v2_ambre_tronque_conseil: 'Reprenez-le en entier, bien à plat.',
    v2_ambre_nom_titre: 'Le nom ne se lit pas',
    v2_ambre_nom_conseil: 'Reprenez la photo à plat, sans reflet.',
    v2_ambre_date_titre: 'La date de validité ne se lit pas',
    v2_ambre_date_conseil: 'Reprenez la photo à plat, sans reflet.',
    v2_ambre_perime_titre: 'Ce document semble périmé',
    v2_ambre_perime_conseil: 'Envoyez un document en cours de validité.',
    v2_ambre_mismatch_titre: 'Le nom ne correspond pas à la réservation',
    v2_ambre_mismatch_conseil: 'Envoyez la pièce de la personne qui séjournera.',
    v2_zone_haut: ' en haut',
    v2_zone_bas: ' en bas',
    v2_zone_gauche: ' à gauche',
    v2_zone_droite: ' à droite',
    // Bouton parlant + sous-textes CTA. Le sous-texte de persistance est ALIGNÉ
    // sur le mécanisme réel (sessionStorage : survit au rechargement, PAS à la
    // fermeture — verdict Q-PERSISTANCE : « je ne promets pas ce que je ne
    // tiens pas »). La phrase maquette « si vous quittez la page » est écartée.
    v2_envoyer: 'Envoyer',
    v2_envoyer_manque: 'Envoyer — il manque {x}',
    v2_envoi_en_cours: 'Envoi en cours…',
    v2_ne_fermez_pas: 'Ne fermez pas cette page',
    // Limite RÉELLE (relectures du 28/10) : {date} = « 14 juillet à 17 h » ;
    // sans heure d'arrivée réglée, la limite est minuit au début du jour
    // d'arrivée → « la veille ». Rien n'est affiché si la limite est passée.
    v2_sub_pret: 'Vous pourrez modifier vos réponses jusqu’au {date}',
    v2_sub_pret_veille: 'Vous pourrez modifier vos réponses jusqu’à la veille de votre arrivée',
    v2_sub_persistance: 'Vos réponses sont gardées si la page se recharge.',
    // Écran merci.
    v2_merci_tout_recu: 'Nous avons tout reçu',
    v2_merci_arrivee: 'Votre arrivée est notée pour {h} le {date}. Nous préparons le logement pour cette heure.',
    v2_merci_modif: 'Vous pouvez modifier vos réponses jusqu’au {date}, en rouvrant ce formulaire.',
    v2_merci_modif_veille: 'Vous pouvez modifier vos réponses jusqu’à la veille de votre arrivée, en rouvrant ce formulaire.',
    v2_retour_sejour: 'Retour à mon séjour',
    // Écran expiré (« Écrivez-nous » = mailto).
    v2_expire_titre: 'Ce lien n’est plus valide.',
    v2_expire_lien: 'Écrivez-nous',
    v2_expire_suite: ' et nous vous en renvoyons un tout de suite.',
    // Pied.
    v2_pied_question: '☎ Une question ? Écrivez-nous',
    // Bloc RGPD V2 — titre maquette + paragraphe CONTRÔLE IA validé au mot par
    // Dimitri (GO 2026-09-06), suivi du rgpd_body existant inchangé. Le corps
    // RGPD dessiné dans la maquette (« jamais transmis à un tiers ») est ÉCARTÉ
    // — devenu faux avec le contrôle IA (verdict de la décision GO).
    v2_rgpd_titre: 'Ce que nous faisons de votre pièce',
    v2_rgpd_controle: "Au moment de l'envoi, votre document est analysé automatiquement pour vérifier qu'il est lisible, en cours de validité et au nom de la réservation. Cette analyse est réalisée par un service d'intelligence artificielle hébergé dans l'Union européenne ; votre document n'y est ni conservé, ni utilisé pour un entraînement. Le résultat s'affiche immédiatement, et un échec de l'analyse ne bloque jamais votre envoi.",
  },
  en: {
    // Form ALREADY SENT — read-only.
    recu_titre: 'Received on {date}',
    recu_titre_sans_date: 'Received',
    recu_intro: 'We have received your form. Here are your answers.',
    recu_modif: 'To change an answer, write to us at {email}.',
    recu_piece: 'ID document received',
    recu_btn_modifier: 'Edit my answers',
    recu_modifiable: 'You can edit your answers until {date} (Paris time).',
    recu_modifiable_jour: 'You can edit your answers until the day before your arrival.',
    recu_trop_tard: 'Too late to change online: your change was not saved. Please write to us.',
    recu_autre_reponse: 'Your form was not saved: an answer had already been received for this stay. To change something, please write to us.',
    recu_autre_reponse_modifiable: 'Your form was not saved: an answer had already been received for this stay. To change something, use “Edit my answers”.',
    recu_garder: 'Already received — leave blank to keep it',
    recu_email_aide: 'To change your email address, write to us.',
    recu_val_adresse: 'Address received',
    recu_val_message: 'Message received',
    recu_val_reponse: 'Answer received',
    recu_envoi_en_cours: 'Your form is being processed. Reload the page in a moment.',
    recu_verif_impossible: 'We cannot check right now. Please try again in a moment.',
    hero_subtitle: "Let's prepare your arrival together",
    stay_label: 'Your stay',
    stay_dates: 'From {d1} to {d2}',
    piece_group_title: 'ID document',
    piece_subtext_passport: 'Photograph the page with your photo and information.',
    piece_subtext_recto: 'Front of your ID card.',
    piece_subtext_verso: 'Back of your ID card.',
    submit: '✓ Confirm my arrival',
    submitting: '⏳ Sending…',
    thanks_title: '✅ Thank you!',
    thanks_msg: "Your form has been received. We'll get back to you shortly.",
    redirecting: 'Redirecting…',
    back_to_booking: 'Back to your booking…',
    error_title: '⚠️ Invalid link',
    error_help: 'If you think this is a mistake, please contact your concierge.',
    loading: 'Loading…',
    required_field: 'The "{x}" field is required.',
    upload_required: 'Please upload "{x}" before confirming.',
    upload_in_progress: '"{x}" is still uploading, please wait a few seconds.',
    time_from: 'From {h}',
    checkout_before: 'Check-out before {h}',
    slot_placeholder: '— Choose a time slot —',
    select_placeholder: '— Select —',
    upload_sending: '⏳ Sending…',
    upload_done: '✓ Document uploaded',
    upload_already_received: '✓ Document already received',
    upload_replace_hint: 'Select a file again to {action}.',
    upload_action_replace: 'replace it',
    upload_action_retry: 'try again',
    upload_err_format: 'Unsupported format, please try again with JPEG or PDF.',
    upload_err_generic: 'Upload failed. Please try again.',
    rgpd_toggle: 'Your data is protected',
    rgpd_more: 'learn more',
    rgpd_less: 'hide',
    rgpd_body: 'The document you upload (passport or ID card) is used solely to verify your identity for your stay. It is stored securely and privately, accessible only to the FULLBNBZEN concierge team, and automatically deleted 15 days after the end of your stay. In accordance with the GDPR, you may request access to it or its deletion at {email}.',
    piece_opt_passport: 'Passport',
    piece_opt_ci: 'ID card',
    piece_opt_ts: 'Residence permit',
    piece_subtext_ts_recto: 'Front of your residence permit.',
    piece_subtext_ts_verso: 'Back of your residence permit.',

    // ── FORM V2 (2026-09 redesign) ──
    v2_bonjour: 'Hello {prenom}',
    v2_bonjour_sans_prenom: 'Hello',
    v2_merci_titre: 'Thank you, {prenom}!',
    v2_merci_titre_sans_prenom: 'Thank you!',
    v2_lien_expire: 'Link expired',
    v2_quand_jours: 'Arriving in {n} days',
    v2_quand_jour: 'Arriving in 1 day',
    v2_quand_demain: 'Arriving tomorrow',
    v2_quand_aujourdhui: 'Arriving today',
    v2_fait: '{n}/{tot} done',
    v2_faits: '{n}/{tot} done',
    v2_tout_rempli: 'Everything is filled in, you can send.',
    v2_plus_que: 'Only {x} left.',
    v2_il_reste: '{liste} and {dernier} are left.',
    v2_carte_vous: 'Your contact details',
    v2_carte_horaires: 'Your times',
    v2_carte_piece: 'Your ID document',
    v2_carte_piece_sous: 'the law requires us to collect it',
    v2_carte_mot: 'A word for us',
    v2_carte_autre: 'Other',
    v2_facultatif: 'optional',
    v2_label_email: 'Your email',
    v2_label_phone: 'Your phone',
    v2_label_notes: 'Anything to tell us?',
    v2_ph_notes: 'A question about the home, a special need…',
    v2_label_arrivee: 'Arrival',
    v2_label_depart: 'Departure',
    v2_err_email: 'This address does not look valid — check the @ and the dot.',
    v2_err_champ: 'This field is required.',
    v2_err_horaire: 'Choose a time slot.',
    v2_err_piece: 'Upload this document before confirming.',
    v2_err_piece_en_cours: 'This document is still uploading, please wait a few seconds.',
    v2_horaires_phrase: 'Check-in from {checkin}, check-out before {checkout}. ',
    v2_hc_lien: 'Write to us',
    v2_hc_suite: ' if you arrive outside these times.',
    v2_apres_23h: 'after 11pm',
    v2_quel_document: 'Which document?',
    v2_page_photo: 'The page with your photo',
    v2_aide_photo: 'A sharp photo where the name and validity date are readable.',
    v2_prendre_photo: 'Take a photo',
    v2_appareil: 'the camera opens',
    v2_choisir_fichier: 'Choose a file',
    v2_depuis_tel: 'from my phone',
    v2_reprendre_photo: 'Retake the photo',
    v2_envoi_doc: 'Sending…',
    v2_verif_doc: 'Checking your document…',
    v2_doc_envoye: 'Document sent',
    v2_doc_recu: 'Document received',
    v2_retirer_doc: 'Remove this document',
    v2_ambre_flou_titre: 'The photo is a bit blurry{zone}',
    v2_ambre_flou_conseil: 'Retake it flat, without glare.',
    v2_ambre_reflet_titre: 'A glare makes it hard to read{zone}',
    v2_ambre_reflet_conseil: 'Retake the photo without flash, away from a lamp.',
    v2_ambre_cadrage_titre: 'The document is cut off{zone}',
    v2_ambre_cadrage_conseil: 'Retake it fully inside the frame.',
    v2_ambre_sombre_titre: 'The photo is too dark{zone}',
    v2_ambre_sombre_conseil: 'Retake it near a window.',
    v2_ambre_tronque_titre: 'Part of the document is missing{zone}',
    v2_ambre_tronque_conseil: 'Retake it in full, laid flat.',
    v2_ambre_nom_titre: 'The name cannot be read',
    v2_ambre_nom_conseil: 'Retake the photo flat, without glare.',
    v2_ambre_date_titre: 'The validity date cannot be read',
    v2_ambre_date_conseil: 'Retake the photo flat, without glare.',
    v2_ambre_perime_titre: 'This document seems expired',
    v2_ambre_perime_conseil: 'Send a document that is still valid.',
    v2_ambre_mismatch_titre: 'The name does not match the booking',
    v2_ambre_mismatch_conseil: 'Send the ID of the person who will be staying.',
    v2_zone_haut: ' at the top',
    v2_zone_bas: ' at the bottom',
    v2_zone_gauche: ' on the left',
    v2_zone_droite: ' on the right',
    v2_envoyer: 'Send',
    v2_envoyer_manque: 'Send — {x} is missing',
    v2_envoi_en_cours: 'Sending…',
    v2_ne_fermez_pas: 'Do not close this page',
    v2_sub_pret: 'You can edit your answers until {date}',
    v2_sub_pret_veille: 'You can edit your answers until the day before your arrival',
    v2_sub_persistance: 'Your answers are kept if the page reloads.',
    v2_merci_tout_recu: 'We have received everything',
    v2_merci_arrivee: 'Your arrival is noted for {h} on {date}. We are preparing the home for that time.',
    v2_merci_modif: 'You can edit your answers until {date} by opening this form again.',
    v2_merci_modif_veille: 'You can edit your answers until the day before your arrival by opening this form again.',
    v2_retour_sejour: 'Back to my stay',
    v2_expire_titre: 'This link is no longer valid.',
    v2_expire_lien: 'Write to us',
    v2_expire_suite: ' and we will send you a new one right away.',
    v2_pied_question: '☎ A question? Write to us',
    // RGPD block — EN paragraph VALIDATED word for word by Dimitri (2026-09-06).
    v2_rgpd_titre: 'What we do with your ID',
    v2_rgpd_controle: 'When you send it, your document is automatically checked to make sure it is readable, still valid, and in the name on the booking. This check is done by an artificial-intelligence service hosted in the European Union; your document is neither stored there nor used for training. The result appears immediately, and if the check fails, your submission is never blocked.',
  },
  es: {
    // Formulario YA ENVIADO — solo lectura.
    recu_titre: 'Recibido el {date}',
    recu_titre_sans_date: 'Recibido',
    recu_intro: 'Hemos recibido su formulario. Estas son sus respuestas.',
    recu_modif: 'Para cambiar una respuesta, escríbanos a {email}.',
    recu_piece: 'Documento de identidad recibido',
    recu_btn_modifier: 'Modificar mis respuestas',
    recu_modifiable: 'Puede modificar sus respuestas hasta el {date} (hora de París).',
    recu_modifiable_jour: 'Puede modificar sus respuestas hasta la víspera de su llegada.',
    recu_trop_tard: 'Demasiado tarde para modificar en línea: su cambio no se ha guardado. Escríbanos.',
    recu_autre_reponse: 'Su envío no se ha guardado: ya se había recibido una respuesta para esta estancia. Para cambiar algo, escríbanos.',
    recu_autre_reponse_modifiable: 'Su envío no se ha guardado: ya se había recibido una respuesta para esta estancia. Para cambiar algo, utilice «Modificar mis respuestas».',
    recu_garder: 'Ya recibido — déjelo vacío para conservarlo',
    recu_email_aide: 'Para cambiar su dirección de correo electrónico, escríbanos.',
    recu_val_adresse: 'Dirección recibida',
    recu_val_message: 'Mensaje recibido',
    recu_val_reponse: 'Respuesta recibida',
    recu_envoi_en_cours: 'Su envío se está procesando. Recargue la página en un momento.',
    recu_verif_impossible: 'No podemos comprobarlo ahora. Inténtelo de nuevo en un momento.',
    hero_subtitle: 'Preparemos juntos su llegada',
    stay_label: 'Su estancia',
    stay_dates: 'Del {d1} al {d2}',
    piece_group_title: 'Documento de identidad',
    piece_subtext_passport: 'Fotografíe la página con su foto y sus datos.',
    piece_subtext_recto: 'Anverso de su documento de identidad.',
    piece_subtext_verso: 'Reverso de su documento de identidad.',
    submit: '✓ Confirmar mi llegada',
    submitting: '⏳ Enviando…',
    thanks_title: '✅ ¡Gracias!',
    thanks_msg: 'Hemos recibido su formulario. Le responderemos en breve.',
    redirecting: 'Redirigiendo…',
    back_to_booking: 'Volviendo a su reserva…',
    error_title: '⚠️ Enlace no válido',
    error_help: 'Si cree que es un error, póngase en contacto con su conserjería.',
    loading: 'Cargando…',
    required_field: 'El campo «{x}» es obligatorio.',
    upload_required: 'Suba «{x}» antes de confirmar.',
    upload_in_progress: '«{x}» se está subiendo, espere unos segundos.',
    time_from: 'A partir de las {h}',
    checkout_before: 'Salida antes de las {h}',
    slot_placeholder: '— Elegir un horario —',
    select_placeholder: '— Seleccionar —',
    upload_sending: '⏳ Enviando…',
    upload_done: '✓ Documento enviado',
    upload_already_received: '✓ Documento ya recibido',
    upload_replace_hint: 'Vuelva a seleccionar un archivo para {action}.',
    upload_action_replace: 'reemplazarlo',
    upload_action_retry: 'reintentar',
    upload_err_format: 'Formato no admitido, inténtelo de nuevo en JPEG o PDF.',
    upload_err_generic: 'El envío ha fallado. Inténtelo de nuevo.',
    rgpd_toggle: 'Sus datos están protegidos',
    rgpd_more: 'más información',
    rgpd_less: 'ocultar',
    rgpd_body: 'El documento que sube (pasaporte o documento de identidad) se utiliza únicamente para verificar su identidad durante su estancia. Se almacena de forma segura y privada, accesible solo para el equipo de conserjería FULLBNBZEN, y se elimina automáticamente 15 días después del final de su estancia. De conformidad con el RGPD, puede solicitar su acceso o su eliminación en {email}.',
    piece_opt_passport: 'Pasaporte',
    piece_opt_ci: 'Documento de identidad',
    piece_opt_ts: 'Permiso de residencia',
    piece_subtext_ts_recto: 'Anverso de su permiso de residencia.',
    piece_subtext_ts_verso: 'Reverso de su permiso de residencia.',

    // ── FORMULARIO V2 (rediseño 2026-09) ──
    v2_bonjour: 'Hola, {prenom}',
    v2_bonjour_sans_prenom: 'Hola',
    v2_merci_titre: '¡Gracias, {prenom}!',
    v2_merci_titre_sans_prenom: '¡Gracias!',
    v2_lien_expire: 'Enlace caducado',
    v2_quand_jours: 'Llegada en {n} días',
    v2_quand_jour: 'Llegada en 1 día',
    v2_quand_demain: 'Llegada mañana',
    v2_quand_aujourdhui: 'Llegada hoy',
    v2_fait: '{n}/{tot} hecho',
    v2_faits: '{n}/{tot} hechos',
    v2_tout_rempli: 'Todo está completo, puede enviar.',
    v2_plus_que: 'Solo falta {x}.',
    v2_il_reste: 'Faltan {liste} y {dernier}.',
    v2_carte_vous: 'Sus datos de contacto',
    v2_carte_horaires: 'Sus horarios',
    v2_carte_piece: 'Su documento de identidad',
    v2_carte_piece_sous: 'la ley nos obliga a recogerlo',
    v2_carte_mot: 'Unas palabras para nosotros',
    v2_carte_autre: 'Otros',
    v2_facultatif: 'opcional',
    v2_label_email: 'Su correo electrónico',
    v2_label_phone: 'Su teléfono',
    v2_label_notes: '¿Algo que comunicarnos?',
    v2_ph_notes: 'Una pregunta sobre el alojamiento, una necesidad particular…',
    v2_label_arrivee: 'Llegada',
    v2_label_depart: 'Salida',
    v2_err_email: 'Esta dirección no parece válida — compruebe la @ y el punto.',
    v2_err_champ: 'Este campo es obligatorio.',
    v2_err_horaire: 'Elija un horario.',
    v2_err_piece: 'Suba este documento antes de confirmar.',
    v2_err_piece_en_cours: 'Este documento se está subiendo, espere unos segundos.',
    v2_horaires_phrase: 'Entrada a partir de las {checkin}, salida antes de las {checkout}. ',
    v2_hc_lien: 'Escríbanos',
    v2_hc_suite: ' si llega fuera de estos horarios.',
    v2_apres_23h: 'después de las 23h',
    v2_quel_document: '¿Qué documento?',
    v2_page_photo: 'La página con su foto',
    v2_aide_photo: 'Una foto nítida donde se lean el nombre y la fecha de validez.',
    v2_prendre_photo: 'Hacer una foto',
    v2_appareil: 'se abre la cámara',
    v2_choisir_fichier: 'Elegir un archivo',
    v2_depuis_tel: 'desde mi teléfono',
    v2_reprendre_photo: 'Repetir la foto',
    v2_envoi_doc: 'Enviando…',
    v2_verif_doc: 'Comprobando su documento…',
    v2_doc_envoye: 'Documento enviado',
    v2_doc_recu: 'Documento recibido',
    v2_retirer_doc: 'Retirar este documento',
    v2_ambre_flou_titre: 'La foto está un poco borrosa{zone}',
    v2_ambre_flou_conseil: 'Repítala en plano, sin reflejos.',
    v2_ambre_reflet_titre: 'Un reflejo dificulta la lectura{zone}',
    v2_ambre_reflet_conseil: 'Repita la foto sin flash, lejos de una lámpara.',
    v2_ambre_cadrage_titre: 'El documento está cortado{zone}',
    v2_ambre_cadrage_conseil: 'Repítala con el documento entero en el encuadre.',
    v2_ambre_sombre_titre: 'La foto está demasiado oscura{zone}',
    v2_ambre_sombre_conseil: 'Repítala cerca de una ventana.',
    v2_ambre_tronque_titre: 'Falta una parte del documento{zone}',
    v2_ambre_tronque_conseil: 'Repítala con el documento entero, bien plano.',
    v2_ambre_nom_titre: 'El nombre no se puede leer',
    v2_ambre_nom_conseil: 'Repita la foto en plano, sin reflejos.',
    v2_ambre_date_titre: 'La fecha de validez no se puede leer',
    v2_ambre_date_conseil: 'Repita la foto en plano, sin reflejos.',
    v2_ambre_perime_titre: 'Este documento parece caducado',
    v2_ambre_perime_conseil: 'Envíe un documento en vigor.',
    v2_ambre_mismatch_titre: 'El nombre no coincide con la reserva',
    v2_ambre_mismatch_conseil: 'Envíe el documento de la persona que se alojará.',
    v2_zone_haut: ' en la parte superior',
    v2_zone_bas: ' en la parte inferior',
    v2_zone_gauche: ' a la izquierda',
    v2_zone_droite: ' a la derecha',
    v2_envoyer: 'Enviar',
    v2_envoyer_manque: 'Enviar — falta {x}',
    v2_envoi_en_cours: 'Enviando…',
    v2_ne_fermez_pas: 'No cierre esta página',
    v2_sub_pret: 'Podrá modificar sus respuestas hasta el {date}',
    v2_sub_pret_veille: 'Podrá modificar sus respuestas hasta la víspera de su llegada',
    v2_sub_persistance: 'Sus respuestas se conservan si la página se recarga.',
    v2_merci_tout_recu: 'Lo hemos recibido todo',
    v2_merci_arrivee: 'Su llegada está anotada para las {h} del {date}. Preparamos el alojamiento para esa hora.',
    v2_merci_modif: 'Puede modificar sus respuestas hasta el {date} volviendo a abrir este formulario.',
    v2_merci_modif_veille: 'Puede modificar sus respuestas hasta la víspera de su llegada volviendo a abrir este formulario.',
    v2_retour_sejour: 'Volver a mi estancia',
    v2_expire_titre: 'Este enlace ya no es válido.',
    v2_expire_lien: 'Escríbanos',
    v2_expire_suite: ' y le enviaremos uno nuevo enseguida.',
    v2_pied_question: '☎ ¿Una pregunta? Escríbanos',
    // Bloque RGPD — párrafo ES VALIDADO palabra por palabra (Dimitri 2026-09-06).
    v2_rgpd_titre: 'Qué hacemos con su documento',
    v2_rgpd_controle: 'Al enviarlo, su documento se analiza automáticamente para comprobar que es legible, está en vigor y coincide con el nombre de la reserva. Este análisis lo realiza un servicio de inteligencia artificial alojado en la Unión Europea; su documento no se conserva allí ni se utiliza para entrenamiento. El resultado se muestra al instante, y un fallo del análisis nunca bloquea su envío.',
  },
}

// ── Limite de modification affichée (relectures du 28/10, point 1) ────────
// Instant ISO → « 14 juillet à 17 h » / « 14 July at 17:00 » / « 14 de julio
// a las 17:00 », toujours en heure de Paris. '' si illisible.
const LIMITE_LOCALE = { fr: 'fr-FR', en: 'en-GB', es: 'es-ES' }
export function formatLimiteModification(lang, iso) {
  if (!iso) return ''
  const d = new Date(iso)
  if (isNaN(d.getTime())) return ''
  const l = normalizeFormLocale(lang)
  let parts
  try {
    parts = new Intl.DateTimeFormat(LIMITE_LOCALE[l] || 'fr-FR', {
      timeZone: 'Europe/Paris', day: 'numeric', month: 'long', hour: '2-digit', minute: '2-digit', hourCycle: 'h23',
    }).formatToParts(d)
  } catch (_) {
    return ''
  }
  const v = {}
  for (const p of parts) if (p.type !== 'literal') v[p.type] = p.value
  if (!v.day || !v.month || v.hour == null || v.minute == null) return ''
  const hh = String(parseInt(v.hour, 10))
  if (l === 'en') return `${v.day} ${v.month} at ${hh.padStart(2, '0')}:${v.minute}`
  if (l === 'es') return `${v.day} de ${v.month} a las ${hh.padStart(2, '0')}:${v.minute}`
  return `${v.day} ${v.month} à ${hh} h${v.minute === '00' ? '' : ` ${v.minute}`}`
}

/**
 * Phrase de limite de modification, ou null s'il n'y a rien à promettre.
 * @param {string} lang
 * @param {{jusqu_au: string, avec_heure: boolean}|null} limite — servie par
 *   /api/form-config (limite_modification) ; null = aucune promesse.
 * @param {{date: string, veille: string}} cles — clés du dictionnaire.
 * @param {number} [now] — Date.now() ; limite passée → null (onglet resté ouvert).
 */
export function texteLimiteModification(lang, limite, cles, now = Date.now()) {
  if (!limite || typeof limite !== 'object' || !limite.jusqu_au) return null
  const fin = new Date(limite.jusqu_au).getTime()
  if (isNaN(fin) || now >= fin) return null
  if (limite.avec_heure !== true) return t(lang, cles.veille)
  const date = formatLimiteModification(lang, limite.jusqu_au)
  return date ? t(lang, cles.date, { date }) : null
}

// Libellé d'affichage traduit d'une option id_type, à partir de sa VALEUR FR
// canonique. Inconnu → renvoie la valeur telle quelle (custom admin).
export function pieceOptionLabel(lang, frValue) {
  if (frValue === 'Passeport') return t(lang, 'piece_opt_passport')
  if (frValue === "Carte d'identité") return t(lang, 'piece_opt_ci')
  if (frValue === 'Titre de séjour') return t(lang, 'piece_opt_ts')
  return frValue
}

// Normalise une locale entrante (query/state) → locale supportée ou défaut.
export function normalizeFormLocale(loc) {
  return FORM_LOCALES.includes(loc) ? loc : DEFAULT_FORM_LOCALE
}

// t(lang, key, vars?) — chaîne traduite, fallback FR si clé/locale absente,
// interpolation des {tokens}. {email} = FORM_CONTACT_EMAIL injecté d'office.
export function t(lang, key, vars = {}) {
  const locale = normalizeFormLocale(lang)
  const raw = (DICT[locale] && DICT[locale][key]) ?? DICT.fr[key] ?? key
  const all = { email: FORM_CONTACT_EMAIL, ...vars }
  return String(raw).replace(/\{(\w+)\}/g, (m, k) => (all[k] != null ? String(all[k]) : m))
}

// ── Labels STANDARD du formulaire (décision Dimitri) ─────────────────────────
// Les champs par défaut (forms-migration) ont des libellés FIXES et connus → on
// les traduit par DICTIONNAIRE (fiable, instantané, gratuit), PAS par IA. L'IA
// (api/form-translate) ne sert QUE pour les libellés CUSTOM créés par l'admin.
// Clé = reference (stable). Chaque entrée porte son libellé FR canonique : on ne
// traduit en statique QUE si le libellé courant == le libellé FR par défaut (=
// non personnalisé). Sinon → null → l'IA prend le relais.
const STD_FIELD_LABELS = {
  email:          { fr: 'Email',                        en: 'Email',              es: 'Correo electrónico' },
  phone:          { fr: 'Téléphone',                    en: 'Phone',              es: 'Teléfono' },
  time_in:        { fr: "Heure d'arrivée",              en: 'Arrival time',       es: 'Hora de llegada' },
  time_out:       { fr: 'Heure de départ',              en: 'Departure time',     es: 'Hora de salida' },
  comments:       { fr: 'Commentaires',                 en: 'Comments',           es: 'Comentarios' },
  notes:          { fr: 'Notes',                        en: 'Notes',              es: 'Notas' },
  id_type:        { fr: "Type de pièce d'identité",     en: 'ID document type',   es: 'Tipo de documento de identidad' },
  passport_photo: { fr: "Page d'identité du passeport", en: 'Passport photo page', es: 'Página de identidad del pasaporte' },
  id_recto:       { fr: 'Recto',                        en: 'Front',              es: 'Anverso' },
  id_verso:       { fr: 'Verso',                        en: 'Back',               es: 'Reverso' },
  billing_address:{ fr: 'Adresse facturation',          en: 'Billing address',    es: 'Dirección de facturación' },
  ts_recto:       { fr: 'Recto du titre de séjour',     en: 'Residence permit — front', es: 'Anverso del permiso de residencia' },
  ts_verso:       { fr: 'Verso du titre de séjour',     en: 'Residence permit — back',  es: 'Reverso del permiso de residencia' },
}

// Titre + description par défaut (forms-migration / défaut produit) — traduits
// en statique. Match sur whitespace normalisé (tolère espaces/retours parasites).
const STD_CONTENT = [
  {
    fr: "Formulaire d'accueil",
    en: 'Welcome form', es: 'Formulario de bienvenida',
  },
  {
    // Défaut produit (forms-migration UNIFIED_DEFAULT.description).
    fr: 'Merci de remplir ce formulaire pour préparer votre arrivée. À bientôt, Néïsia & Dimitri - Fullbnbzen',
    en: 'Please fill out this form to prepare for your arrival. See you soon, Néïsia & Dimitri - Fullbnbzen',
    es: 'Por favor, rellene este formulario para preparar su llegada. Hasta pronto, Néïsia & Dimitri - Fullbnbzen',
  },
  {
    // Variante très répandue (texte utilisé en prod sur les logements actifs).
    fr: "Merci de remplir ce formulaire, cela nous permet de préparer au mieux votre arrivée. L'équipe FULLBNBZEN",
    en: 'Please fill out this form so we can best prepare for your arrival. The FULLBNBZEN team',
    es: 'Por favor, rellene este formulario para que podamos preparar mejor su llegada. El equipo FULLBNBZEN',
  },
]
// Normalisation tolérante : collapse des espaces ET suppression de l'espace
// AVANT ponctuation (« formulaire , cela » == « formulaire, cela » — variante
// réelle constatée en prod). Sinon le static-first raterait la description.
const _norm = (s) => String(s || '').replace(/\s+([,.;:!?])/g, '$1').replace(/\s+/g, ' ').trim()

// staticFieldLabel(lang, reference, currentLabel) → libellé traduit si le champ
// est STANDARD et NON personnalisé (currentLabel == défaut FR), sinon null.
export function staticFieldLabel(lang, reference, currentLabel) {
  const loc = normalizeFormLocale(lang)
  const e = STD_FIELD_LABELS[reference]
  if (!e) return null
  if (_norm(currentLabel) !== _norm(e.fr)) return null // personnalisé → IA
  return e[loc] || e.fr
}

// staticContentTr(lang, frStr) → traduction du titre/description par défaut
// (match whitespace-normalisé), sinon null (→ IA, sous garde-fou).
export function staticContentTr(lang, frStr) {
  const loc = normalizeFormLocale(lang)
  const n = _norm(frStr)
  if (!n) return null
  const hit = STD_CONTENT.find((c) => _norm(c.fr) === n)
  return hit ? (hit[loc] || hit.fr) : null
}
